import React from 'react';
import PropTypes from 'prop-types';
import LoginController from '../controllers/LoginController';
import { Redirect, Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import LoadingButton from '../components/LoadingButton';
import AvatarPage from './AvatarPage';

const styles = (theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
    }
});

/**
 * Página de login. Realiza a autenticação do usuário e redireciona para o menu principal
 */
class LoginPage extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        //Controlares
        this.loginController = new LoginController();
        //Estado inicial
        this.state = {
            login: '',
            senha: '',
            mensagem: '',
            autenticado: false,
            carregando: false
        };
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Executa quando o form é submetido.
     * @param {*} event Objeto contendo os dados do evento
     */
    async handleSubmit(event) {
        //Impede a propagação do evento
        event.preventDefault();
        this.setState({ carregando: true });
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        state.carregando = false;
        //Executa o login
        const result = await this.loginController.login(this.state.login, this.state.senha);
        if (!result.sucesso) {
            //Caso tenha ocorrido um erro durante o login, define a mensagem
            state.mensagem = result.mensagem;
        } else {
            //Caso contrário, marca o usuário como autenticado
            state.autenticado = true;
        }
        //Atualiza o estado
        this.setState(state);
        //Executa o callback para atualizar o estado da aplicação
        if (result.sucesso && this.props.onLogin)
            this.props.onLogin();
    }

    render() {
        const { classes } = this.props;
        const { login, senha, mensagem, autenticado } = this.state;
        if (autenticado)
            return <Redirect to="/" />;
        return (
            <AvatarPage>
                <Typography component="h1" variant="h5">Bem-vindo</Typography>
                <form onSubmit={this.handleSubmit} >
                    <Grid container>
                        <Grid item xs={12} >
                            <TextField 
                                name="login" 
                                label="Login" 
                                type="text" 
                                placeholder="Email ou celular" 
                                required
                                variant="outlined" 
                                margin="normal" 
                                fullWidth 
                                value={login} 
                                onChange={this.handleChange} 
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <TextField
                                name="senha" 
                                label="Senha" 
                                type="password" 
                                required
                                variant="outlined" 
                                margin="normal" 
                                fullWidth 
                                value={senha} 
                                onChange={this.handleChange} 
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <Typography id="error-message">{mensagem}</Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <LoadingButton 
                                fullWidth 
                                variant="contained" 
                                color="primary" 
                                type="submit"
                                className={classes.submit} 
                                loading={this.state.carregando}
                            >
                                Entrar
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={12} >
                            <Button 
                                variant="text" 
                                color="default" 
                                component={Link}
                                to="/recuperarSenha"
                            >
                                Esqueci minha senha
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </AvatarPage>
        );
    }
}

LoginPage.propTypes = {
    /** Classes CSS utilizadas pela página */
    classes: PropTypes.shape({
        paper: PropTypes.any,
        avatar: PropTypes.any,
        submit: PropTypes.any
    }),
    /** Callback quando o login for realizado com sucesso */
    onLogin: PropTypes.func
};

export default withStyles(styles)(LoginPage);